import { tap } from 'rxjs/operators';
import { CrudServiceBase } from '@utils';
import { httpService } from '@services/http';
import { logger } from '@services/logger';
import { ParkAreaService } from '@services/park-area';
import { Site } from './site.class';

type Entity = Site;

export class SiteService extends CrudServiceBase<Entity> {
	constructor() {
		super(Site, 'site');
	}

	updateBulk(sites: Partial<Site>[]) {
		return httpService
			.patch<unknown>(this.getUrl(), 'bulk/update', { body: sites, errorHandler: 'notification' })
			.pipe(tap((result) => logger.debug(`[${this.constructor.name}.${this.updateBulk.name}]`, result)));
	}

	parkArea(siteId: string) {
		return new ParkAreaService(siteId);
	}
}

export const siteService = new SiteService();
